import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../common/loader";
import { formateDate, formateDateWithMonth } from "../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { Details } from "../../services/userTransaction.service";
import Breadcrums from "../../common/breadcrumbs";
import { Placeholder} from "rsuite";

const TransactionDetailView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_transaction_detail"),
      url: "/admin/subscription/transaction/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    Details(params._id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{t("btn_view") + " " + t("label_transaction_detail")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>
                    
                        <tr>
                          <th>{t("label_name")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.userDetails && showdefault.userDetails.name
                              ? showdefault.userDetails.name
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_email")}</th>
                          <td>
                          {showdefault && showdefault.userDetails && showdefault.userDetails.email
                              ? showdefault.userDetails.email
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_transaction_id")}</th>
                          <td>
                          {showdefault && showdefault.transactionID 
                              ? showdefault.transactionID
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Type</th>
                          <td>
                            {(() => {
                              const typeMap = {
                                appointment_payment:   { label: "Appointment",       cls: "badge-primary-light" },
                                subscription:          { label: "Subscription",       cls: "badge-success-light" },
                                checkr_fee:            { label: "Checkr Background",  cls: "badge-warning-light" },
                                early_termination_fee: { label: "Early Termination",  cls: "badge-danger-light"  },
                              };
                              const txType = typeMap[showdefault?.transactionType];
                              return txType
                                ? <span className={`badge badge-pill ${txType.cls} text-capitalize`}>{txType.label}</span>
                                : <span className="badge badge-pill badge-secondary-light text-capitalize">{showdefault?.transactionType || "N/A"}</span>;
                            })()}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_intent_id")}</th>
                          <td>
                          {showdefault && showdefault.paymentIntentID 
                              ? showdefault.paymentIntentID
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_charge_id")}</th>
                          <td>
                          {showdefault && showdefault.chargeID 
                              ? showdefault.chargeID
                              : "N/A"}
                          </td>
                        </tr>


                        <tr>
                          <th>{t("list_heading_status")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.status 
                              ? showdefault.status
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>Discount</th>
                          <td>
                            {showdefault && showdefault.discount 
                              ? (showdefault.transactionType === "appointment_payment" ? `$${showdefault.discount}` : `$${showdefault.discount / 100}`)
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_price")}</th>
                          <td className="text-capitalize">
                            {showdefault?.subscriptionPrice != null
                              ? `$${showdefault.subscriptionPrice}`
                              : showdefault?.amount != null
                              ? `$${showdefault.amount}`
                              : "N/A"}
                          </td>
                        </tr>

                        
                        <tr>
                          <th>{t("label_paid_by")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.paidBy 
                              ? `${showdefault.paidBy}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_refunded_amount")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.amountRefunded 
                              ? `$${showdefault.amountRefunded}`
                              : "N/A"}
                          </td>
                        </tr>

                       

                        

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.createdAt 
                              ? `${formateDateWithMonth(showdefault.createdAt)}`
                              : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_expire_date")}</th>
                          <td className="text-capitalize">
                            {showdefault && showdefault.userSubDetails && showdefault.userSubDetails.endDate
                              ? `${formateDateWithMonth(showdefault.userSubDetails.endDate)}`
                              : "N/A"}
                          </td>
                        </tr>




                       


              

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark"
                type="button"
                onClick={() =>
                  navigate("/admin/subscription/transaction/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TransactionDetailView;
